import { Grid, styled } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledSongItemContainerBase = styled(Grid)(({ theme }) => ({
  background: theme.palette.grey[800],
  padding: theme.spacing(2, 0),
}));

export const StyledSongItemContainer = (
  props: ComponentProps<typeof StyledSongItemContainerBase>
) => (
  <StyledSongItemContainerBase container item alignItems="center" {...props} />
);
